import { Popover } from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Avatar from "react-avatar";
import { Link, useHistory } from "react-router-dom";
import { Alert } from "rsuite";
import { Context } from "../../../Context";
import mobilytix_logo from "../../../assets/images/mobilytix_logo.png";
import satisfi_logo from "../../../assets/images/satisfi_white.svg";
import Loader from "../../../components/Loader";
import constants, { newUIConstants } from "../../../constants";
import useAxiosHook from "../../../hooks/useAxiosHook";
import { postAxios, putAxios } from "../../utils/axios";
import { NewButton } from "../Button";
import CustomIcon from "../CustomIcon";
import NotificationIndex from "./NotificationIndex";
import ProfileCard from "./ProfileCard";
import "./index.scss";

const brandLogo =
	constants.brandLogo !== "satisfi_white.svg" ? mobilytix_logo : satisfi_logo;
export default function NewHeader() {
	const context = useContext(Context);
	const history = useHistory();

	const [notifications, setNotifications] = useState([]);
	const [isFullScreenLoading, setIsFullScreenLoading] = useState(false);
	const [showPill, setShowPill] = useState(false);
	const [pillMessage, setPillMessage] = useState("");
	const { get } = useAxiosHook();

	useEffect(() => {
		context.getProfilePictureFunc();
		getNotifications();
		getPlan();
	}, [context.getProfilePictureFunc]);

	useEffect(() => {
		if (
			context.wallet_data.expires_on < 0 &&
			context.wallet_data.current_account_status === "Suspended"
		) {
			//change global css variable
			document.documentElement.style.setProperty("--extraHeight", "30px");

			setShowPill(true);
			setPillMessage(
				"Your subscription has expired and your account is suspended. Please purchase a new subscription to activate your account",
			);
		} else {
			document.documentElement.style.setProperty("--extraHeight", "0px");
		}
	}, [context.wallet_data]);

	const getPlan = async () => {
		try {
			const userPlan = await get(newUIConstants.userPlan);
			window.localStorage.setItem(
				"send_time_recomm_enabled",
				userPlan.send_time_recommendation,
			);
			context.setUserPlan(userPlan);
			if (userPlan) {
				try {
					if (location.pathname === "/") {
						if (userPlan?.name?.toLowerCase().startsWith("free")) {
							history.push("?user=free");
						} else {
							history.push("?user=subscriber");
						}
					}
				} catch (e) {
					console.log("warning to be checked", e);
					if (location.pathname === "/") {
						history.push("?user=free");
					}
				}
			}
		} catch (e) {
			context.setUserPlan({ name: "Free", isOldAccount: true });
			const searchParams = new URLSearchParams(location.search);
			const token = searchParams.get("token");
			const code = searchParams.get("code");
			if (!code && !token) history.push("?user=free");
		}
	};

	const logout = async () => {
		try {
			setIsFullScreenLoading(true);
			await postAxios(constants.graphql, {
				query: `mutation {
                    updateUser(input: {
                        where: { id: "${window.localStorage.getItem("id")}" },
                        data: { last_login: "${moment().toISOString()}" }
                    }) {
                        user { id }
                    }
                }`,
			});
			await postAxios(constants.logout, {});
		} catch (e) {
			console.log(e);
		} finally {
			context.clear_state();
			window.localStorage.clear();
			Alert.success("Logout successfully, Goodbye!", constants.alertDuration);

			setTimeout(() => {
				history.push("/signin");
				window.location.reload();
			}, 500);
		}
	};

	const getNotifications = () => {
		context.getAllNotificationsFunc().then((res) => {
			if (!res) return;
			const row = [];
			for (const key of res) {
				if (!key.acknowledged && res.length > 0) {
					row.push(key);
				}
			}
			setNotifications(row);
		});
	};

	const updateNotification = async (id) => {
		try {
			await putAxios(`${constants.notifications}/${Number(id)}`, {
				acknowledged: true,
			});
		} catch (error) {
			console.log(error);
		}
	};

	const viewAllNotifications = () => {
		//TODO: can make a route later to pass list of id to change the state of the notification instead of passing one by one
		for (const item of notifications) {
			updateNotification(item.key);
		}
		history.push("/notifications");
	};

	return (
		<>
			<div className="base">
				<Loader loading={isFullScreenLoading} />
				<div
					style={{
						width: 220,
						marginLeft: 16,
					}}
				>
					<Link to="/">
						<img
							src={brandLogo}
							alt=""
							style={{ height: "30px", width: "auto" }}
						/>
					</Link>
				</div>
				<div className="flex-1" />
				<div className="right-side">
					{context.userPlan?.name?.toLowerCase().startsWith("free") && (
						<>
							<div
								className="mr-fix"
								style={{ fontSize: 10, color: "#fff", fontStyle: "italic" }}
							>
								On FREE Plan
							</div>
							<div
								className="upgrade-btn"
								onClick={() => history.push("/settings/plan-details")}
							>
								UPGRADE
							</div>
						</>
					)}

					<CustomIcon
						size={24}
						stateChangeable={true}
						icon="question"
						onClick={() => window.open("https://docs.satisfilabs.com/resource-center/marketing-engine/")}
					/>
					<Popover
						className="notification-popover"
						content={
							context.contact_upload_count.execution_index &&
							context.contact_upload_count.execution_index > 0 ? (
								<div className="notification-card">
									<span className="notification-key">Inserting contact:</span>
									<span className="notification-value">
										{context.contact_upload_count.execution_index}
									</span>
								</div>
							) : notifications && notifications.length > 0 ? (
								<div className="notify">
									<div className="notifications">
										{notifications.map((item, index) => (
											<NotificationIndex
												item={item}
												index={index}
												key={item.date + item.name}
											/>
										))}
									</div>
									<NewButton
										outlined={false}
										onClick={() => viewAllNotifications()}
										className="full-width"
										autoWidth={false}
									>
										View all
									</NewButton>
								</div>
							) : (
								<div className="notify" style={{ width: 414, height: 185 }}>
									<div className="flex-col flex-alc">
										<div style={{ height: 150 }} className="flex flex-alc">
											<p style={{ fontSize: 16, fontWeight: 500 }}>
												No new notifications
											</p>
										</div>
										<NewButton
											outlined={false}
											onClick={() => history.push("/notifications")}
											className="full-width"
											autoWidth={false}
										>
											View all
										</NewButton>
									</div>
								</div>
							)
						}
						title={
							<div style={{ fontSize: "15px", padding: "5px 0px" }}>
								{context.contact_upload_count.execution_index > 0
									? "Notifications"
									: "Notification"}
							</div>
						}
						placement="bottomRight"
						style={{ padding: 0, zIndex: "99999 !important" }}
					>
						<div className="header-pbutton-notification">
							<CustomIcon
								size={20}
								stateChangeable={true}
								icon={"notification"}
							/>
							{notifications.length > 0 ? (
								<div className="notification-length">
									{notifications.length}
								</div>
							) : null}
						</div>
					</Popover>

					<Popover
						placement="bottomRight"
						align={{ offset: [0, -10] }}
						showArrow={false}
						zIndex={9999}
						overlayInnerStyle={{ borderRadius: 10 }}
						content={
							<ProfileCard
								context={context}
								logout={logout}
								plan={context.userPlan?.name}
							/>
						}
						trigger="click"
					>
						<div className="profile-image-container">
							<Avatar
								size={32}
								round="32px"
								name={context.full_name}
								src={context.profile_picture_url}
							/>
						</div>
					</Popover>
				</div>
			</div>

			<div className="gap" />

			{showPill && (
				<>
					<div className="expire-pill">{pillMessage}</div>
					<div style={{ height: 30 }} />
				</>
			)}
		</>
	);
}
